export default {"src":"/_next/static/media/chat.55bc5537.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};